module.exports = __webpack_public_path__ + "img/right.9c1da4c7.webp";